<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene11',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
    this.$container.removeChild(this.$scene)
  },

  created() {

    const sprites = {}
    this.$sprites = sprites
    const path = {}

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.$container.addChild(this.$scene)
    this.$parent.$scene11 = this.$scene

    const container = new Container()
          container.alpha = 0
    this.$scene.addChild(container)

    const block = new Container()
          block.scale.set(2.18)
          block.x += 1
          block.y += 16
    
    container.addChild(block)
    this.setCenterContainer(block)

    const whirlpool = new Container()
          whirlpool.x += 0

    container.addChild(whirlpool)
    this.setCenterContainer(whirlpool)

    const tl = new TimelineMax()
    const sub0 = new TimelineMax()
    const sub1 = new TimelineMax()
    const sub1_1 = new TimelineMax()
    const sub2 = new TimelineMax()
    const sub3 = new TimelineMax()
    const sub4 = new TimelineMax()
    const sub5 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    let plafond_hd = (this.$root.above('tablet')) 
        ? { container: block, alpha: 0, scale: this.$root.$scale*1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, x: -2, y: -128 }
        : { ref: 'plafond_hd_half', container: block, alpha: 0, scale: this.$root.$scale_optimize*1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, x: -2, y: -128 }

    let wave = (this.$root.above('tablet')) 
        ? { container: whirlpool, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, y: 1162 }
        : { ref: 'wave_half', container: whirlpool, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, y: 1162, scale: 1 }

    let masque = (this.$root.above('tablet')) 
        ? { container: whirlpool, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, y: 1162 }
        : { ref: 'masque_half', container: whirlpool, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, y: 1162, scale: 1 }

    const els = {
      'grey': { ref: 'grey_s11', container: block, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }},
      'plafond_hd': plafond_hd,
      'decor': { container: block, alpha: 0, scale: this.$root.$scale*2.18, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, x: -2, y: -128 },
      'statue_color': { container: block, alpha: 0.75, scale: this.$root.$scale*2.18*2, position: { x: 0, y: 0, width: 1536, height: 2160 }, x: -2, y: -200, pivot: { x: 1, y: 644 }},
      'deck': { container: block, alpha: 1, scale: this.$root.$scale*2.30*2, position: { x: 0, y: 0, width: 1536, height: 2160 }, x: -2, y: -128, pivot: { x: 1, y: 859 }}, 
      'floor': { container: block, alpha: 0, scale: this.$root.$scale*2.18, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, x: -2, y: -128 },
      'deck_color': { container: block, alpha: 0, scale: this.$root.$scale*2.18, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, x: -2, y: -128 },
      'front': { ref: 'front_s11', container: block, alpha: 0, scale: this.$root.$scale*2.18, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, x: -2, y: -128 },
      'suspend': { container: block, alpha: 0, scale: this.$root.$scale*2.18, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, x: -2, y: -128 },
      'bg_purple': { container: block, alpha: 0, scale: this.$root.$scale*2.18, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, x: -2, y: -128 },
      'wave_purple': { container: whirlpool, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 } },
      'doors': { container: whirlpool, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, y: 2 },
      'wave': wave,
      'masque': masque,
      'greenman': { container: whirlpool, alpha: 0, anchor: { x: 0.5, y: 0.5 }, scale: this.$root.$scale*1.25, y: 200  },
      'wave_grey': { container: whirlpool, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0 } },
      'doors_purple': { container: whirlpool, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, y: 2 },
      'sub1_1_plante1': { ref: 'plante1', container: block, alpha: 1, scale: this.$root.$scale*1.40, anchor: { x: 1, y: 0.5 }, rotation: 105, x:-700, y: 1100 },
      'sub1_1_plante2': { ref: 'plante2', container: block, alpha: 1, scale: this.$root.$scale*1.52, anchor: { x: 1, y: 0.5 }, x: 900, y: -720 },
      'sub1_1_plante4': { ref: 'plante4', container: block, alpha: 1, scale: this.$root.$scale*1.48, anchor: { x: 0, y: 1.0 }, rotation: -125, x: 768, y: 800 },
      'sub1_1_fish1': { ref: 'fish', container: block, alpha: 0, x: 400, y: 400, scale: 0 },
      'sub1_1_fish2': { ref: 'fish', container: block, alpha: 0, x: 0, y: 0, scale: 0 },
      'sub1_1_wolf': { ref: 'wolf', container: block, alpha: 0, x: 200, y: 500, scale: 0 },
      'sub1_1_bird_1': { ref: 'bird1', container: block, alpha: 0, x: -300, y: -700, scale: 0 },
      'sub1_1_bird_2': { ref: 'bird2', container: block, alpha: 0, x: -500, y: -400, scale: 0 },
    }

    _.each(els, (el, name)=>{
      let sp = null
      const _name = (el.ref) ? el.ref : name
      const sprite = new Sprite.from(this.$resources[_name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.anchor.set(.5)
            sprite.alpha = el.alpha
      if(!el.pivot) { sp = sprite }
      else {
        const cn = new Sprite()
        sprite.x = el.pivot.x/2
        sprite.y = el.pivot.y/2 
        cn.addChild(sprite)
        sp = cn
      }
      el.container.addChild(sp)
      sprites[name] = sp
      this.applySettings(sp, el)
    })

    this.$els = els

    const df = [-200, -100, -0, 0, 100, 200]
    const getPath = ()=>{
      return  [
        { x: 192+df[_.random(0,5)], y: 270+df[_.random(0,5)] },
        { x: -192+df[_.random(0,5)], y: -270+df[_.random(0,5)] },
        { x: -540, y: -1000 }
      ]
    }

    const getBezierScale = (name, tempo, pixi, delay)=>{
      const tl1 = new TimelineMax()
            .to(sprites[name], tempo, { bezier:{ type:"soft", values: path[name]}, pixi: pixi, ease: Linear.easeNone })
      const tl2 = new TimelineMax()
            .to(sprites[name], tl1.duration()*0.25, { pixi:{ alpha: 1 }, ease: Linear.easeNone })
            .to(sprites[name], tl1.duration()*0.50, { pixi:{ alpha: 0 }, ease: Linear.easeNone })
      const tl3 = new TimelineMax()
      if(name != 'wolf_1') {
        tl3
          .to(sprites[name], tl1.duration()*0.25, { pixi:{ scale: this.$root.$scale*_.random(0.75, 1) }, ease: Linear.easeNone })
          .to(sprites[name], tl1.duration()*0.25, { pixi:{ scale: this.$root.$scale*_.random(0.5, 1.4) }, ease: Linear.easeNone })
          .to(sprites[name], tl1.duration()*0.50, { pixi:{ scale: this.$root.$scale*_.random(0.25, 1) }, ease: Linear.easeNone })
      }
      const merge = new TimelineMax({ delay: delay })
            .add([ tl1, tl2, tl3 ])
      return merge
    }

    const getData = ()=>{
      return {
        alpha: _.random(0.75, 1),
        container: whirlpool,
        x: 1000 + df[_.random(0,5)],
        y: 1000 + df[_.random(0,5)]
      }
    }

    const elements = [
      { name: 'bird1', nb: 5 },
      { name: 'bird2', nb: 5 },
      { name: 'fish', nb: 10 },
      { name: 'plante1', nb: 10 },
      { name: 'plante2', nb: 10 },
      { name: 'plante3', nb: 10 },
      { name: 'plante4', nb: 10 },
      { name: 'extra1', nb: 20 },
      { name: 'extra2', nb: 20 },
      { name: 'extra3', nb: 20 },
      { name: 'wolf', nb: 1 },
      { name: 'f1', nb: 5 },
      { name: 'f2', nb: 5 },
    ]

    _.each(elements, (data)=>{
      for(var i=1; i<data.nb+1; i++) {
        const name = data.name + '_'+ i
        let el = getData()
        let sc = this.$root.$scale*_.random(0.5, 1.2)
        if(data.name === 'wolf') {
          sc = 1.4
          el.x = 1500
          el.y = 1500
        }
        if(name === 'fish_2')
          sc = 0.3
        const sprite = new Sprite.from(this.$resources[data.name].texture) 
              sprite.scale.set(sc)
              sprite.anchor.set(0.5)
              sprite.alpha = el.alpha
        el.container.addChild(sprite)
        sprites[name] = sprite
        path[name] = getPath()
        this.applySettings(sprite, el)
      }
    })

    sprites['greenman'].mask = sprites['masque']

    // ******************************************************** //
    // ******************************************************** //

    const createBezier = (names) => {
      const tlb = new TimelineMax()
            .to(sprites.sub1_1_plante1, 5*this.$coef, { pixi:{ alpha: 1, scale: this.$root.$scale * _.random(1, 2) }, ease: Linear.easeNone })
            .to(sprites.sub1_1_plante2, 5*this.$coef, { pixi:{ alpha: 1, scale: this.$root.$scale * _.random(1, 2) }, ease: Linear.easeNone })
            .to(sprites.sub1_1_plante3, 5*this.$coef, { pixi:{ alpha: 1, scale: this.$root.$scale * _.random(1, 2) }, ease: Linear.easeNone })
      _.each(names, name => {
        TweenMax.set(sprites[name], { pixi: { x: 500, y: 500 } })
        tlb
          .to(sprites[name], 5*this.$coef, { 
            pixi:{
              alpha: 1,
              y: _.random(-100, 100),
              x: _.random(-100, 100),
              scale: this.$root.$scale * _.random(1.5, 2)
            }, 
            ease: Linear.easeNone 
          }, '-=' + _.random(4*this.$coef, 5*this.$coef))
          .to(sprites[name], 5*this.$coef, { pixi:{ alpha: 0, y: _.random(-500, -700), x: _.random(-500, -700), scale: this.$root.$scale * 1 }, ease: Linear.easeNone })
      })
      tlb.to([
        sprites.sub1_1_plante1,
        sprites.sub1_1_plante2,
        sprites.sub1_1_plante3,
        ..._.map(names, n => sprites[n])
      ], 5*this.$coef, { pixi:{ alpha: 0 }, ease: Linear.easeNone })

      return tlb
    }

    const createAnimalsBezier = (names)=>{

      const coef = 0.15
      const tlb = new TimelineMax()
            .add([
              TweenMax.from(sprites.sub1_1_plante1, 2, { pixi:{ alpha: 0, rotation: 50 }, ease: Expo.easeOut }),
              TweenMax.from(sprites.sub1_1_plante2, 2, { pixi:{ alpha: 0 }, ease: Cubic.easeOut, delay: 1*coef }),
              TweenMax.to(sprites.sub1_1_plante2, 2, { pixi:{ rotation: 0 }, ease: Cubic.easeOut, delay: 1*coef }),
              TweenMax.from(sprites.sub1_1_plante4, 1, { pixi:{ alpha: 0, y: 900 }, ease: Cubic.easeOut }),
            ])

      TweenMax.set(sprites['sub1_1_fish1'], { pixi: { x: 1200, y: 250, alpha: 0.2 } })
      TweenMax.set(sprites['sub1_1_fish2'], { pixi: { x: 1200, y: 250, alpha: 0.2 } })

      tlb
        .to(sprites['sub1_1_fish1'], 1.5, {
          bezier: { type: "soft", values:[ { x: 0, y: -400 }, { x: -1500, y: 100 } ] },
          pixi: { alpha: 1, rotation: -45, scale: this.$root.$scale * _.random(1.5, 2) },
          ease: Linear.easeNone
       })

      tlb
        .to(sprites['sub1_1_fish2'], 1.5, {
          bezier: { type: "soft", values:[ { x: 0, y: -400 }, { x: -1500, y: 100 } ] },
          pixi: { alpha: 1, rotation: -45, scale: this.$root.$scale * 0.7 },
          ease: Linear.easeNone
       })

      TweenMax.set(sprites['sub1_1_wolf'], { pixi: { x: 500, y: 300 } })

      tlb
        .to(sprites['sub1_1_wolf'], 5*coef, { 
          pixi:{
            alpha: 1,
            y: _.random(-100, 100),
            x: _.random(-100, 100),
            scale: this.$root.$scale * _.random(1.5, 2)
          }, 
          ease: Linear.easeNone 
        }, '-=' + _.random(4*coef, 5*coef))
        .to(sprites['sub1_1_wolf'], 5*coef, { pixi:{ alpha: 0, y: _.random(-500, -700), x: _.random(-500, -700) }, ease: Linear.easeNone })

      TweenMax.set(sprites['sub1_1_bird_1'], { pixi: { x: 500, y: 300 } })
      TweenMax.set(sprites['sub1_1_bird_2'], { pixi: { x: 500, y: 300 } })

      tlb
        .set({}, { delay: 1 })
        .to(sprites['sub1_1_bird_1'], 5*coef, { 
          pixi:{
            alpha: 1,
            y: _.random(-100, 100),
            x: _.random(-100, 100),
            scale: this.$root.$scale * _.random(1.5, 2)
          }, 
          ease: Linear.easeNone 
        }, '-=' + _.random(4*coef, 5*coef))
        .to(sprites['sub1_1_bird_1'], 5*coef, { pixi:{ alpha: 0, y: _.random(-500, -700), x: _.random(-700, -900) }, ease: Linear.easeNone })

      tlb
        .to(sprites['sub1_1_bird_2'], 5*coef, { 
          pixi:{
            alpha: 1,
            y: _.random(-100, 100),
            x: _.random(-100, 100),
            scale: this.$root.$scale * _.random(1.5, 2)
          }, 
          ease: Linear.easeNone 
        }, '-=' + _.random(4*coef, 5*coef))
        .to(sprites['sub1_1_bird_2'], 5*coef, { pixi:{ alpha: 0, y: _.random(-500, -700), x: _.random(-700, -900) }, ease: Linear.easeNone })

      tlb.to([
        sprites.sub1_1_plante1,
        sprites.sub1_1_plante2,
        sprites.sub1_1_plante4,
        ..._.map(names, n => sprites[n])
      ], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone })  

      return tlb

    }

    // ******************************************************** //
    // ******************************************************** //

    // const alfa_filter = new PIXI.filters.AlphaFilter(0.0)
    // container.filters = [ alfa_filter ]

    this.$coef = 0.15

    const tempo = 2*this.$coef
    const appear = tempo*100

    const alphaFilter = new PIXI.filters.AlphaFilter(0)
    whirlpool.filters = [ alphaFilter ]

    TweenMax.set(block, { pixi:{ saturation: 0 } })

    sub0
      // .to(alfa_filter, 1, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ container.filters = null } })
      .to(container, 1, { alpha: 1, ease: Linear.easeNone })
      .add([
        TweenMax.to(block, appear*0.20, { pixi:{ scale: 0.47, x: '-='+ 0, y: '+='+ 52 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['statue_color'], appear*0.20, { pixi:{ y: -128, alpha: 1 }, ease: Linear.easeNone }),
      ])

    sub1
      .to(sprites['plafond_hd'], tempo*4, { pixi:{ alpha: 1 }, ease: Linear.easeNone })
      .add([
        TweenMax.to(sprites['deck'], tempo*1, { pixi:{ scale: this.$root.$scale*2.18*2 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['front'], tempo*3, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: tempo*3.8 }),
        TweenMax.to(block, tempo*2, { pixi:{ saturation: 1 }, ease: Linear.easeNone, delay: tempo*2 })
      ])

    sub1_1
      .set({}, { delay: 3.25 })
      .to(sprites.bg_purple, 1, { pixi:{ alpha: 1 }, ease: Linear.easeNone })
      .add(createAnimalsBezier(['sub1_1_fish1', 'sub1_1_fish1', 'sub1_1_wolf', 'sub1_1_bird_1', 'sub1_1_bird_2']))

    sub2
      .add([
        TweenMax.to([sprites.wave_purple, sprites.wave, sprites.wave_grey], appear*.2, { pixi: { alpha: 1 } }),
        TweenMax.to(sprites['wave'], appear*0.25, { y: -1036, ease: Linear.easeNone }),
        TweenMax.to(sprites['masque'], appear*0.25, { y: -1036, ease: Linear.easeNone }),
      ])
      .set(sprites['wave'], { y: 1162, ease: Linear.easeNone })
      .set(sprites['masque'], { y: 1162, ease: Linear.easeNone })
      .add([
        TweenMax.to(sprites['wave'], appear*0.25, { y: -1036, ease: Linear.easeNone }),
        TweenMax.to(sprites['masque'], appear*0.25, { y: -1036, ease: Linear.easeNone }),
      ])
      .set(sprites['wave'], { y: 1162, ease: Linear.easeNone })
      .set(sprites['masque'], { y: 1162, ease: Linear.easeNone })
      .add([
        TweenMax.to(sprites['wave'], appear*0.25, { y: -1036, ease: Linear.easeNone }),
        TweenMax.to(sprites['masque'], appear*0.25, { y: -1036, ease: Linear.easeNone }),
      ])
      .set(sprites['wave'], { y: 1162, ease: Linear.easeNone })
      .set(sprites['masque'], { y: 1162, ease: Linear.easeNone })
      .add([
        TweenMax.to(sprites['wave'], appear*0.25, { y: -1036, ease: Linear.easeNone }),
        TweenMax.to(sprites['masque'], appear*0.25, { y: -1036, ease: Linear.easeNone }),
      ])

    sub3
      .set({}, { delay: 0 })
      .add([

        getBezierScale('bird1_1', appear*0.075, { rotation: 15 }, 0),
        getBezierScale('bird2_1', appear*0.075, { rotation: 15 }, 1),
        getBezierScale('plante1_1', appear*0.075, { rotation: 40 }, 1.5 ),

        getBezierScale('extra2_1', appear*0.075, { rotation: -50 }, 2.5 ),
        getBezierScale('extra2_2', appear*0.075, { rotation: 20 }, 2.75 ),
        getBezierScale('plante1_2', appear*0.075, { rotation: 100 }, 4 ),
        getBezierScale('f2_1', appear*0.075, { rotation: 10 }, 5 ),

        TweenMax.to(sprites['greenman'], appear*0.10, { pixi:{  alpha:1, scale: this.$root.$scale*0.95, y: 0 }, ease: Cubic.easeOut, delay: 6 }),
        TweenMax.to(sprites['greenman'], appear*0.20, { pixi:{  alpha:0, scale: this.$root.$scale*0.5 }, ease: Cubic.easeOut, delay: 9 }),

        getBezierScale('plante3_2', appear*0.075, { rotation: -20 }, 7 ),
        getBezierScale('extra2_4', appear*0.075, { rotation: 20 }, 8 ),
        getBezierScale('extra1_4', appear*0.075, { rotation: 20 }, 8.25 ),
        getBezierScale('plante1_3', appear*0.075, { rotation: 60 }, 10 ),
        getBezierScale('extra2_5', appear*0.075, { rotation: 20 }, 11 ),
        getBezierScale('f1_2', appear*0.075, { rotation: 10 }, 12 ),

        getBezierScale('plante3_3', appear*0.075, { rotation: -20 }, 13 ),
        getBezierScale('plante1_6', appear*0.075, { rotation: 25 }, 14 ),

        getBezierScale('plante1_7', appear*0.075, { rotation: 50 }, 15 ),
        getBezierScale('extra2_8', appear*0.075, { rotation: -5 }, 15.5 ),
        getBezierScale('extra1_8', appear*0.075, { rotation: 20 }, 16 ),
        getBezierScale('bird2_2', appear*0.075, { rotation: 15 }, 17.5),
        getBezierScale('plante3_8', appear*0.075, { rotation: -20 }, 18 ),

        getBezierScale('f1_3', appear*0.075, { rotation: 10 }, 19 ),
        getBezierScale('f2_3', appear*0.075, { rotation: 10 }, 20 ),
        getBezierScale('bird1_4', appear*0.075, { rotation: 15 }, 21.5),

      ])

    sub4
      .add([
        TweenMax.to(sprites['doors'], appear*0.20, { alpha: 1, ease: Linear.easeNone }),
      ])
      .to(sprites['doors_purple'], appear*0.10, { alpha: 1, ease: Linear.easeNone })

    tl.add(sub0)
      .add(sub1, '-='+ 20*this.$coef)
      .add(sub1_1)
      .to(alphaFilter, 2, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ whirlpool.filters = null } })
      .add(sub2)
      .add(sub3, '-=' + (sub2.duration() - 10*this.$coef))
      .add(sub4, '-='+ 60*this.$coef)

    this.$tl.add(tl, 5)


  },
  mounted() {

    // console.log('Scene11');
    // this.$parent.chapter.$tl.seek(54)
   
  }
}
</script>
